import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Trash2, Loader2 } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import { useTranslation } from 'react-i18next';

interface ClearCacheButtonProps {
  statisticId: string;
  statisticTitle: string;
  onCacheCleared?: () => void;
}

export const ClearCacheButton: React.FC<ClearCacheButtonProps> = ({
  statisticId,
  statisticTitle,
  onCacheCleared
}) => {
  const [isClearing, setIsClearing] = useState(false);
  const { toast } = useToast();
  const { t } = useTranslation();

  const handleClearCache = async () => {
    if (isClearing) return;
    
    setIsClearing(true);
    
    try {
      const response = await fetch(`/api/statistics/${statisticId}/clear-cache`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to clear cache');
      }

      const result = await response.json();
      
      toast({
        title: "Cache Limpiado",
        description: `Cache limpiado para: ${result.statisticTitle}`,
        variant: "default",
      });

      // Callback para refrescar datos si es necesario
      if (onCacheCleared) {
        onCacheCleared();
      }

    } catch (error) {
      console.error('Error clearing cache:', error);
      toast({
        title: "Error",
        description: "No se pudo limpiar el cache",
        variant: "destructive",
      });
    } finally {
      setIsClearing(false);
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleClearCache}
      disabled={isClearing}
      className="text-xs"
      title={`Limpiar cache de: ${statisticTitle}`}
    >
      {isClearing ? (
        <Loader2 className="h-3 w-3 animate-spin" />
      ) : (
        <Trash2 className="h-3 w-3" />
      )}
      <span className="ml-1">Cache</span>
    </Button>
  );
};

export default ClearCacheButton;
